import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/Branch";
const request = HttpService.handleRequest();

export const BranchService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate,
  getAllList,
  getAllListForDropdown,
  InsertBranchWithoutPickupIntegration,
  InsBranchIntegrationSiga
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}/InsertByProc`, data);
}

async function update(data) {
  return request.post(`${basePath}/InsertByProc`, data);
}

async function del(data) {
  return request.delete(`${basePath}/DeleteById/${data.id}`);
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

// Retorna filiais filtradas por usuario
async function getAllList() {
  return request.get(basePath+'/GetAllList');
}

async function getAllListForDropdown() {
  return request.get(basePath+'/GetAllForDropdown');
}

async function InsertBranchWithoutPickupIntegration(data) {
  return request.post(basePath+'/InsertBranchWithoutPickupIntegration', data);
}

async function InsBranchIntegrationSiga(data) {
  return request.post(basePath+'/InsBranchIntegrationSiga', data);
}

export default BranchService;